export function getSelectionDistances(selectedId, relationships) {
  const distances = new Map();
  if (!selectedId) return distances;
  const neighbours = new Map();
  for (const { parentId, childId } of relationships) {
    if (!neighbours.has(parentId)) neighbours.set(parentId, []);
    if (!neighbours.has(childId)) neighbours.set(childId, []);
    neighbours.get(parentId).push(childId);
    neighbours.get(childId).push(parentId);
  }
  const queue = [selectedId];
  distances.set(selectedId, 0);
  for (let index = 0; index < queue.length; index += 1) {
    const id = queue[index];
    for (const neighbour of neighbours.get(id) || []) {
      if (distances.has(neighbour)) continue;
      distances.set(neighbour, distances.get(id) + 1);
      queue.push(neighbour);
    }
  }
  return distances;
}

export function selectionOpacity(distances, nodeId) {
  if (!distances.size) return 1;
  return [1, 0.85, 0.65, 0.5][distances.get(nodeId)] ?? 0.4;
}
